export const comuni: string[] = [
  "Acquafondata",
  "Acuto",
  "Alatri",
  "Alvito",
  "Amaseno",
  "Anagni",
  "Aquino",
  "Arce",
  "Arnara",
  "Arpino",
  "Atina",
  "Ausonia",
  "Belmonte Castello",
  "Boville Ernica",
  "Broccostella",
  "Campoli Appennino",
  "Casalattico",
  "Casalvieri",
  "Cassino",
  "Castelliri",
  "Castelnuovo Parano",
  "Castro dei Volsci",
  "Castrocielo",
  "Ceccano",
  "Ceprano",
  "Cervaro",
  "Colfelice",
  "Colle San Magno",
  "Collepardo",
  "Coreno Ausonio",
  "Esperia",
  "Falvaterra",
  "Ferentino",
  "Filettino",
  "Fiuggi",
  "Fontana Liri",
  "Fontechiari",
  "Frosinone",
  "Fumone",
  "Gallinaro",
  "Giuliano di Roma",
  "Guarcino",
  "Isola del Liri",
  "Monte San Giovanni Campano",
  "Morolo",
  "Paliano",
  "Pastena",
  "Patrica",
  "Pescosolido",
  "Picinisco",
  "Pico",
  "Piedimonte San Germano",
  "Piglio",
  "Pignataro Interamna",
  "Pofi",
  "Pontecorvo",
  "Posta Fibreno",
  "Ripi",
  "Rocca d'Arce",
  "Roccasecca",
  "San Biagio Saracinisco",
  "San Donato Val di Comino",
  "San Giorgio a Liri",
  "San Giovanni Incarico",
  "San Vittore del Lazio",
  "Sant'Ambrogio sul Garigliano",
  "Sant'Andrea del Garigliano",
  "Sant'Apollinare",
  "Sant'Elia Fiumerapido",
  "Santopadre",
  "Serrone",
  "Settefrati",
  "Sgurgola",
  "Sora",
  "Strangolagalli",
  "Supino",
  "Terelle",
  "Torre Cajetani",
  "Torrice",
  "Trevi nel Lazio",
  "Trivigliano",
  "Vallecorsa",
  "Vallemaio",
  "Vallerotonda",
  "Veroli",
  "Vicalvi",
  "Vico nel Lazio",
  "Villa Latina",
  "Villa Santa Lucia",
  "Villa Santo Stefano",
  "Viticuso",
  "Aprilia",
  "Bassiano",
  "Campodimele",
  "Castelforte",
  "Cisterna di Latina",
  "Cori",
  "Fondi",
  "Formia",
  "Gaeta",
  "Itri",
  "Latina",
  "Lenola",
  "Maenza",
  "Minturno",
  "Monte San Biagio",
  "Norma",
  "Pontinia",
  "Ponza",
  "Priverno",
  "Prossedi",
  "Rocca Massima",
  "Roccagorga",
  "Roccasecca dei Volsci",
  "Sabaudia",
  "San Felice Circeo",
  "Santi Cosma e Damiano",
  "Sermoneta",
  "Sezze",
  "Sonnino",
  "Sperlonga",
  "Spigno Saturnia",
  "Terracina",
  "Ventotene",
  "Accumoli",
"Amatrice",
"Antrodoco",
"Ascrea",
"Belmonte in Sabina",
"Borbona",
"Borgo Velino",
"Borgorose",
"Cantalice",
"Cantalupo in Sabina",
"Casaprota",
"Casperia",
"Castel di Tora",
"Castel Sant'Angelo",
"Castelnuovo di Farfa",
"Cittaducale",
"Cittareale",
"Collalto Sabino",
"Colle di Tora",
"Collegiove",
"Collevecchio",
"Colli sul Velino",
"Concerviano",
"Configni",
"Contigliano",
"Cottanello",
"Fara in Sabina",
"Fiamignano",
"Forano",
"Frasso Sabino",
"Greccio",
"Labro",
"Leonessa",
"Longone Sabino",
"Magliano Sabina",
"Marcetelli",
"Micigliano",
"Mompeo",
"Montasola",
"Monte San Giovanni in Sabina",
"Montebuono",
"Monteleone Sabino",
"Montenero Sabino",
"Montopoli di Sabina",
"Morro Reatino",
"Nespolo",
"Orvinio",
"Paganico Sabino",
"Pescorocchiano",
"Petrella Salto",
"Poggio Bustone",
"Poggio Catino",
"Poggio Mirteto",
"Poggio Moiano",
"Poggio Nativo",
"Poggio San Lorenzo",
"Posta",
"Pozzaglia Sabina",
"Rieti",
"Rivodutri",
"Rocca Sinibalda",
"Roccantica",
"Salisano",
"Scandriglia",
"Selci",
"Stimigliano",
"Tarano",
"Toffia",
"Torri in Sabina",
"Torricella in Sabina",
"Turania",
"Vacone",
"Varco Sabino",
"Affile",
"Agosta",
"Albano Laziale",
"Allumiere",
"Anguillara Sabazia",
"Anticoli Corrado",
"Anzio",
"Arcinazzo Romano",
"Ardea",
"Ariccia",
"Arsoli",
"Artena",
"Bellegra",
"Bracciano",
"Camerata Nuova",
"Campagnano di Roma",
"Canale Monterano",
"Canterano",
"Capena",
"Capranica Prenestina",
"Carpineto Romano",
"Casape",
"Castel Gandolfo",
"Castel Madama",
"Castel San Pietro Romano",
"Castelnuovo di Porto",
"Cave",
"Cerreto Laziale",
"Cervara di Roma",
"Cerveteri",
"Ciampino",
"Ciciliano",
"Cineto Romano",
"Civitavecchia",
"Civitella San Paolo",
"Colleferro",
"Colonna",
"Fiano Romano",
"Filacciano",
"Fiumicino",
"Fonte Nuova",
"Formello",
"Frascati",
"Gallicano nel Lazio",
"Gavignano",
"Genazzano",
"Genzano di Roma",
"Gerano",
"Gorga",
"Grottaferrata",
"Guidonia Montecelio",
"Jenne",
"Labico",
"Ladispoli",
"Lanuvio",
"Lariano",
"Licenza",
"Magliano Romano",
"Mandela",
"Manziana",
"Marano Equo",
"Marcellina",
"Marino",
"Mazzano Romano",
"Mentana",
"Monte Compatri",
"Monte Porzio Catone",
"Monteflavio",
"Montelanico",
"Montelibretti",
"Monterotondo",
"Montorio Romano",
"Moricone",
"Morlupo",
"Nazzano",
"Nemi",
"Nerola",
"Nettuno",
"Olevano Romano",
"Palestrina",
"Palombara Sabina",
"Percile",
"Pisoniano",
"Poli",
"Pomezia",
"Ponzano Romano",
"Riano",
"Rignano Flaminio",
"Riofreddo",
"Rocca Canterano",
"Rocca di Cave",
"Rocca di Papa",
"Rocca Priora",
"Rocca Santo Stefano",
"Roccagiovine",
"Roiate",
"Roma",
"Roviano",
"Sacrofano",
"Sambuci",
"San Cesareo",
"San Gregorio da Sassola",
"San Polo dei Cavalieri",
"San Vito Romano",
"Sant'Angelo Romano",
"Sant'Oreste",
"Santa Marinella",
"Saracinesco",
"Segni",
"Subiaco",
"Tivoli",
"Tolfa",
"Torrita Tiberina",
"Trevignano Romano",
"Vallepietra",
"Vallinfreda",
"Valmontone",
"Velletri",
"Vicovaro",
"Vivaro Romano",
"Zagarolo",
"Acquapendente",
"Arlena di Castro",
"Bagnoregio",
"Barbarano Romano",
"Bassano in Teverina",
"Bassano Romano",
"Blera",
"Bolsena",
"Bomarzo",
"Calcata",
"Canepina",
"Canino",
"Capodimonte",
"Capranica",
"Caprarola",
"Carbognano",
"Castel Sant'Elia",
"Castiglione in Teverina",
"Celleno",
"Cellere",
"Civita Castellana",
"Civitella d'Agliano",
"Corchiano",
"Fabrica di Roma",
"Faleria",
"Farnese",
"Gallese",
"Gradoli",
"Graffignano",
"Grotte di Castro",
"Ischia di Castro",
"Latera",
"Lubriano",
"Marta",
"Montalto di Castro",
"Monte Romano",
"Montefiascone",
"Monterosi",
"Nepi",
"Onano",
"Oriolo Romano",
"Orte",
"Piansano",
"Proceno",
"Ronciglione",
"San Lorenzo Nuovo",
"Soriano nel Cimino",
"Sutri",
"Tarquinia",
"Tessennano",
"Tuscania",
"Valentano",
"Vallerano",
"Vasanello",
"Vejano",
"Vetralla",
"Vignanello",
"Villa San Giovanni in Tuscia",
"Viterbo",
"Vitorchiano"
]
